export const STAT_TYPE = "STAT";
export const STATS_DEADLINES_ACTION = `${STAT_TYPE}_DEADLINES`;
export const STATS_CHARTS_ACTION = `${STAT_TYPE}_CHARTS`;
